var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.5H12L10.6 5.1C10.2 4.7 9.7 4.5 9.2 4.5H4C2.9 4.5 2 5.4 2 6.5V18.5C2 19.6 2.9 20.5 4 20.5H20C21.1 20.5 22 19.6 22 18.5V8.5C22 7.4 21.1 6.5 20 6.5ZM15 14.5H13V16.5C13 17 12.6 17.5 12 17.5C11.4 17.5 11 17 11 16.5V14.5H9C8.4 14.5 8 14.1 8 13.5C8 12.9 8.4 12.5 9 12.5H11V10.5C11 9.9 11.4 9.5 12 9.5C12.6 9.5 13 9.9 13 10.5V12.5H15C15.5 12.5 16 12.9 16 13.5C16 14.1 15.5 14.5 15 14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPortfolio);
export default __webpack_public_path__ + "static/media/add-portfolio.91c8c826f912b74e98ff7fc445851f0f.svg";
export { ForwardRef as ReactComponent };